import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserIndexComponent } from './crud-index/crud-index.component';
import { UserCESComponent } from './crud-ces/crud-ces.component';
import { UserProfileCESComponent } from './user-profile-ces/crud-ces.component';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';

const routes: Routes = [
  {
    path: '',
    component: UserIndexComponent,
  },
  {
    path: 'create',
    component: UserCESComponent,
    data: [{ action: 'create' }],
  },
  {
    path: 'view/:id',
    component: UserCESComponent,
    data: [{ action: 'view' }],
  },
  {
    path: 'edit/:id',
    component: UserCESComponent,
    data: [{ action: 'edit' }],
  },
  {
    path: 'view-profile/:id',
    component: UserProfileCESComponent,
    data: { type: TypeCesEnum.SHOW },
  },
  {
    path: 'edit-profile/:id',
    component: UserProfileCESComponent,
    data: { type: TypeCesEnum.EDIT },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserRoutingModule { }
